import DashboardPage from "../dashboard/dashboard";

export default function DashboardCompanyPage() {
  return <DashboardPage />;
}
